//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from 'lodash.throttle'
import blok from '~/mixins/blok'
import { legalHubArticleTypeIconsByLabel, legalHubArticleListExcludedFields } from '~/utils/constants'

const urlPathLastPartRegex = /\/[^/]+\/?$/

const mainTitleSelectorStartKey = '@start@'

export default {
  mixins: [blok],

  // Affected by main nav height (which may differ between desktop and mobile btw)
  titleScrollOffset: 170,
  sidebarTopOffset: 170,

  data () {
    const path = this.$route.path
    const parentPath = path.replace(urlPathLastPartRegex, '')

    const hasMainText = this.$sb.isFilledRichText(this.blok.main_text)
    const hasAfterText = this.$sb.isFilledRichText(this.blok.after_text)

    let bottomLayoutBloks = []
    if (this.blok.bottom_layout) {
      const bottomLayoutStory = this.blok.rels.find(x => x.uuid === this.blok.bottom_layout)
      bottomLayoutBloks = bottomLayoutStory.content.blocks
    }

    const pageUrl = 'https://' + this.$config.siteUrl + this.$route.fullPath
    const pageTitle = ''

    return {
      legalHubArticleTypeIconsByLabel,
      containerCls: `${this.$ui.container} !tw-max-w-3xl`,
      introContainerCls: this.blok.youtube_video_id ? ' !tw-mt-15' : '',
      parentPage: parentPath,
      heroImage: this.$sb.parseImage(this.blok.hero_image),
      authorImage: this.$sb.parseImage(this.blok.author_image),
      hasMainText,
      hasAfterText,
      relatedArticles: null,
      relatedTemplates: null,
      bottomLayoutBloks,
      pageUrl,
      pageTitle,
      percentRead: 0,
      mainTextTitles: [],
      mainTextStartsWithTitle: true,
      activeMainTextTitle: null,
    }
  },

  fetchKey (getCounter) {
    return `legal-hub-article:${this.$route.path}:${getCounter('legal-hub-article')}`
  },

  async fetch () {
    await Promise.all([
      this.fetchRelatedArticles(),
      this.fetchRelatedTemplates(),
    ])
  },

  computed: {
    mainTextTitleSelectorOptions () {
      const opts = this.mainTextTitles.map(x => ({ text: x.el.textContent, value: x.el.textContent }))
      if (!this.mainTextStartsWithTitle) {
        opts.unshift({ text: this.$t('legalHub.start'), value: mainTitleSelectorStartKey })
      }
      return opts
    },
  },

  beforeMount () {
    this.pageTitle = document.title
  },

  mounted () {
    if (this.blok.show_table_of_contents) {
      this.parseArticleTitles()

      // Delay computing the pre-scroll article position if the hero image has still to load, it will alter the page length
      if (!this.$refs.heroImage || this.$refs.heroImage.children[0].complete) {
        this.computePercentRead()
        this.computeActiveMainTextTitle()
        this.syncTocScroll()
      } else {
        const imgEl = this.$refs.heroImage.children[0]
        imgEl.addEventListener('load', this.afterHeroImageLoad)
        imgEl.addEventListener('error', this.afterHeroImageLoad)
      }

      const handleArticlePosTracking = (e) => {
        this.computePercentRead()
        this.computeActiveMainTextTitle()
        this.syncTocScroll()
      }

      this.handleArticlePosTracking = throttle(handleArticlePosTracking, 200)

      document.addEventListener('scroll', this.handleArticlePosTracking)
    }
  },

  beforeDestroy () {
    if (this.handleArticlePosTracking) {
      document.removeEventListener('scroll', this.handleArticlePosTracking)
    }
  },

  methods: {
    async fetchRelatedArticles () {
      if (this.blok.related_articles.length === 0) {
        this.relatedArticles = null
        return
      }

      const uuidFilter = this.blok.related_articles.join(',')
      const params = {
        by_uuids_ordered: uuidFilter,
        excluding_fields: legalHubArticleListExcludedFields,
        page: 1,
        per_page: 20,
      }
      const storiesRes = await this.$sb.list('', params)

      this.relatedArticles = storiesRes.data.stories
    },

    async fetchRelatedTemplates () {
      if (!this.blok.related_templates) {
        this.relatedTemplates = null

        return
      }

      const relatedTemplateIds = []
      for (const line of this.blok.related_templates.split('\n')) {
        if (!line) {
          continue
        }
        // We allow the lines to also include the article slug or even a full URL, as long as the last part is the actual template ID.
        const templateId = line.split('/').pop()
        relatedTemplateIds.push(templateId)
      }

      const promises = []
      let anyFailed = false
      for (const templateId of relatedTemplateIds) {
        const promise = this.$api.getTemplate(templateId)
          .catch((e) => {
            anyFailed = true

            // Swallow the error, but the HTTP error should still display in the console, and we also log the collective error message if any requests fail.
            return null
          })
        promises.push(promise)
      }

      const promiseResults = await Promise.all(promises)

      if (anyFailed) {
        // eslint-disable-next-line no-console
        console.warn('One or more related templates failed to load')
      }

      const templateResults = promiseResults.filter(x => x)

      if (!templateResults.length) {
        this.relatedTemplates = null

        return
      }

      this.relatedTemplates = templateResults.map((templateRes) => {
        const template = templateRes.data.data.attributes
        template.id = templateRes.data.data.id
        template.url = this.$url.template(template.id, template.slug)
        return template
      })
    },

    parseArticleTitles () {
      const textEl = this.$refs.mainText
      if (!textEl) {
        return
      }

      const contentEls = textEl.children[0].children

      const startsWithTitle = contentEls.length && contentEls[0].tagName === 'H2'

      const titles = []
      for (const el of contentEls) {
        // Users have a habit of sometimes inputting extraneous empty lines with a heading tag...
        if (el.tagName === 'H2' && el.textContent.trim() !== '') {
          titles.push({ el, children: [] })
        } else if (el.tagName === 'H3' && titles.length && el.textContent.trim() !== '') {
          const parentTitle = titles[titles.length - 1]
          parentTitle.children.push(el)
        }
      }

      this.mainTextTitles = titles
      this.mainTextStartsWithTitle = startsWithTitle
    },

    computePercentRead () {
      const textEl = this.$refs.mainText
      if (!textEl) {
        return
      }

      const textBounds = textEl.getBoundingClientRect()
      const scrollDiff = window.innerHeight - textBounds.top
      const pxTextVisible = Math.min(Math.max(scrollDiff, 0), textBounds.height)

      const percentRead = pxTextVisible / textBounds.height * 100
      const percentReadRounded = Math.floor(percentRead / 5) * 5

      this.percentRead = percentReadRounded
    },

    computeActiveMainTextTitle () {
      const textEl = this.$refs.mainText
      if (!textEl) {
        return
      }

      if (this.forceNextActiveMainTextTitle) {
        if (this.forceNextActiveMainTextTitle.el) {
          this.activeMainTextTitle = this.forceNextActiveMainTextTitle
        } else {
          this.activeMainTextTitle = null
        }

        this.forceNextActiveMainTextTitle = null

        return
      }

      let lastReachedTitle = null
      for (let i = this.mainTextTitles.length - 1; i >= 0; --i) {
        const title = this.mainTextTitles[i]
        const titleBounds = title.el.getBoundingClientRect()
        if (titleBounds.top < window.innerHeight - 50) {
          lastReachedTitle = title
          break
        }
      }

      this.activeMainTextTitle = lastReachedTitle
    },

    syncTocScroll () {
      const titlesContainerEl = this.$refs.tocTitlesContainer
      if (!titlesContainerEl) {
        return
      }

      const activeTitleText = this.activeMainTextTitle ? this.activeMainTextTitle.el.textContent : ''
      let activeTitleEl = null
      for (const titleEl of titlesContainerEl.children) {
        if (titleEl.dataset.title === activeTitleText) {
          activeTitleEl = titleEl
          break
        }
      }

      if (!activeTitleEl) {
        return
      }

      const containerBounds = titlesContainerEl.getBoundingClientRect()
      const titleBounds = activeTitleEl.getBoundingClientRect()
      if (titleBounds.bottom > containerBounds.bottom || titleBounds.top < containerBounds.top) {
        titlesContainerEl.scrollBy({ top: titleBounds.top - containerBounds.top, behavior: 'smooth' })
      }
    },

    scrollToMainTextTitle (title, subTitle = null) {
      // Use this so that the title the user clicked activates, even if a later title would also be visible. Some other title becoming active after clicking would be confusing feedback. When the user scrolls the next time, the active title may freely change again.
      this.forceNextActiveMainTextTitle = title || { el: null }

      if (!title) {
        const bounds = this.$refs.mainText.getBoundingClientRect()
        window.scrollBy({ top: bounds.top - this.$options.titleScrollOffset })
      } else {
        for (const candidate of this.mainTextTitles) {
          if (candidate === title) {
            let el = candidate.el
            if (subTitle) {
              el = candidate.children.find(x => x === subTitle) || el
            }
            const bounds = el.getBoundingClientRect()
            window.scrollBy({ top: bounds.top - this.$options.titleScrollOffset })
            break
          }
        }
      }
    },

    handleMainTextTitleSelector (titleText) {
      if (!titleText) {
        return
      }
      if (titleText === mainTitleSelectorStartKey) {
        this.scrollToMainTextTitle(null)
      } else {
        for (const title of this.mainTextTitles) {
          if (title.el.textContent === titleText) {
            this.scrollToMainTextTitle(title)
            break
          }
        }
      }
    },

    afterHeroImageLoad () {
      this.computePercentRead()
      this.computeActiveMainTextTitle()
      this.syncTocScroll()
    },
  },
}
